// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oiq7","type":"styles_type__1H7rh","choices":"styles_choices__2aYH5"};